<template>
  <a
    href="#offcanvasResponsive"
    class="text-muted ms-auto d-lg-none"
    role="button"
    data-bs-toggle="offcanvas"
    data-bs-target="#offcanvasResponsive"
    aria-controls="offcanvasResponsive"
  >
    <i class="fas fa-list"></i>
  </a>
</template>

<script>
export default {}
</script>

<style></style>
